// @flow
import { applyMiddleware, combineReducers, createStore, compose } from "redux"; 
import thunk from "redux-thunk";
import forensicReducers from "./global/reducers/index";


const reducers = combineReducers({ 
  forensic: forensicReducers
});

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const middleware = [ thunk ];

const store = createStore(
  reducers,
  composeEnhancers( applyMiddleware(...middleware) )
);

export default store;


// WEBPACK FOOTER //
// ./src/store.js